import { useStaticQuery, graphql } from 'gatsby';


export const IndustrialDesign = () => {
	const { wpgraphql } = useStaticQuery(
		graphql`
			query industrialDesignPosts {
				wpgraphql {
					posts(first: 12, where: { categoryName: "industrial-design" }) {
						nodes {
							title
							link
							colourFeatureImage
							featuredImage {
								sourceUrl
								srcSet
								mediaDetails {
									width
									height
								}
							}
							avVideoTeaser {
								avVideoTeaser {
									mediaItemUrl
								}
						  	}
						}
					}
				}
			}
		`
	);

	return wpgraphql.posts.nodes;
};
